export const itemsPerPage = 10;

export const DEFAULT_PAGINATION = {
  totalPages: 0,
  currentPage: 1,
  itemsPerPage,
  totalItems: 0,
};
